import { Component, Host, Prop, h, State, Element, Listen, Method } from '@stencil/core';
import { jitsuClient } from '@jitsu/sdk-js'
// import posthog from 'posthog-js'
// if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
//   posthog.init('phc_PFn3ipf7jR88MXFX73PMM6l7A0G5EeZf0llC0u5FVKv', { api_host: 'https://app.posthog.com', autocapture: false, capture_pageview: false})
// }
// import LazyLoad from "vanilla-lazyload";
// //init
const jitsu = jitsuClient({
    key: "js.ku52f0vferwtf16hunn8p6.s4zhwpli8w7pwz9k0y1kc",
    tracking_host: "https://t.jitsu.com"
});

@Component({
  tag: 'as-photo-viewer',
  styleUrl: 'as-photo-viewer.css',
  shadow: true,
  assetsDirs: ['icons']
})


export class AsPhotoViewer {
  @Element() el: HTMLElement;
  @Prop({ attribute: 'vid' }) photoId: string;
  @Prop() fphoto?: any;
  @Prop({ attribute: 'cid' }) channelId?: string = null;
  @Prop({ attribute: 'pid' }) playlistId?: string = null;
  @Prop() env?: string = '';
  @Prop() showheader?: boolean = true;
  @Prop() showheadertitle?: boolean = true;
  @Prop() showfooterplay?: boolean = false;
  @Prop() showfootertitle?: boolean = false;
  @Prop() showproductchip?: boolean = false;
  @Prop() showproductcard?: boolean = false;
  @Prop({ mutable: true }) w?: string = null;
  @Prop({ mutable: true }) h?: string = null;
  @Prop({ mutable: true }) sw?: number;
  @Prop({ mutable: true }) sh?: number;
  @Prop() fullscreen?: boolean = false;
  @Prop() playclick?: any;
  @Prop() mode?: string = 'story';
  @Prop() position?: string = 'br'; // br tl tr bl - b(bottom), t(top), l(left), r(right)
  // @Prop() margin?: string = '8px'; // margin
  @Prop() piphandler?: any = null;
  @Prop() platform?: any = 'web';
  @Prop({ mutable: true }) widget?: any = 'storyblok';
  @Prop({ mutable: true }) shopify?: boolean = false;
  @Prop() tk: boolean = true;
  @Prop() placeholder?: boolean = true;
  @Prop() productoverlay?: any = null;
  @Prop() index?: number = null;
  @Prop() size?: string = 'default';


  @State() photo: any = null;
  @State() photoUrl: string;
  @State() hidden: boolean = false;
  @State() handlerPipMode?: boolean = false;
  @State() addedToCart?: boolean = false;
  @State() addToCartLoading: boolean = false;
  @State() loading: boolean = true;

  // photoEl!: HTMLVideoElement;
  // private viewer?: HTMLElement;
  private enterPipClick: any;
  private closePipClick: any;
  private backdropClick: any;
  private shopifyProduct: any = null;
  private shopifyVariantId: any = null;
  private shopifyQty: any = 1;
  private playControlClick: any;
  private observer: IntersectionObserver;
  private imgloaded: boolean = false;
  

  @Listen('resize', { target: 'window', passive: true })
  async windowResize() {
    // show a prompt
    var s = this;
    const vidEl = this.el.shadowRoot.querySelector('.as-photo-wrapper');
    this.resetHeight(vidEl, s);
  }

  @Listen('beforeunload', { target: 'window', passive: true })
  async pageExit() {
    // show a prompt
    if(this.photo) {
      // this.trackEvent("page_exit", {
      //   category: this.getViewerCategory(),
      //   ...this.getCtaAttributes(this),
      // });
    }
  }

  
  @Method()
  async load() {
    if(this.loading) {
      setTimeout(this.load, 100);
    }
    else if(!this.imgloaded) {
      try {
      this.loadImg();
      } catch(e) {
        setTimeout(this.load, 100);
      }
    }
  }

  @Method() 
  async closeoverlay() {
    const overlay = this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay');
    overlay?.close(false);
  }

  componentWillLoad() {
    if(this.mode === 'pinned') {
      this.enablePip();
      if(this.widget === 'storyblok') {
        this.widget = 'floating_photo_viewer';
      }
    }

    if(this.piphandler) {
      // console.log('handler pip mode fls', this.fullscreen);
      this.handlerPipMode = true;
    }
  }

  async componentDidLoad() {

    var win: any = window;

      if(!this.sw) {
        this.sw = this.el.getBoundingClientRect().width;
        this.sh = this.el.getBoundingClientRect().height;
        if(this.h) {
          this.sh = parseInt(this.h.replace('px', ''));
        }
      }
      vidEl = this.el.shadowRoot.querySelector('.as-photo-wrapper');
      const s = this;
      this.resetHeight(vidEl, s);


    if(win?.Shopify && this.platform === 'shopify') {
      this.shopify = true;
      if(this.mode === 'pinned') {
        const sp = await this.onShopifyProductPage();
        if(!sp) {
          console.log('not product page - photo viewer wont load');
          return false;
        }
      }
      console.log('shopify product', this.shopifyProduct);
    }

    if(this.fphoto) {
      const finalphoto = this.fphoto;
      this.photoUrl = this.getPhotoUrl(finalphoto);
      this.photo = finalphoto;
    }

    let finalphoto = this.photo || null;

    if(this.placeholder) {
      //placeholder
    }
    if(!this.photo) {
      let cheader = {
        "Content-type": "application/json;charset=UTF-8",
      };

      if(this.channelId) {
        cheader["channel_id"] = this.channelId;
      }
      let vUrl = `${this.getApiUrl(this.env)}/web/photos/`;
      if(this.photoId) {
        vUrl = `${vUrl}${this.photoId}`;
      } else if(this.platform === 'shopify' && this.shopifyProduct?.product?.id) {
        vUrl = `${vUrl}product-photo?productId=${this.shopifyProduct?.product?.id}&platform=shopify`;
      } else {
        console.log('no api to fetch from');
        return false;
      }
      // console.log(vUrl);

      const vidResponse = await fetch(vUrl,
      {
        method: "GET",
        headers: cheader,
      });
      if(vidResponse.status === 200) {
        const vidData = await vidResponse.json();
        finalphoto = vidData;
        this.photoUrl = this.getPhotoUrl(finalphoto);
      } else {
        return false;
      }
    }
    
    if(this.platform === 'shopify' && this.shopify) {
      if(finalphoto?.shoppableType === 'addtocart' && 
      finalphoto.shoppableData?.productId !== this.shopifyProduct.product.id.toString()) {
        console.log('product id doesn\'t match');
        return false;
      }
    } 
    this.photo = finalphoto;
    this.loading = false;

    if(this.tk && this.photo) {
      this.setJitsu(this)
    }


//     const img: HTMLImageElement = 
//     this.el.shadowRoot.querySelector('img');
// ​
//     if (img) {
//       this.observer = new IntersectionObserver(this.onIntersection);
//       this.observer.observe(img);
//     }

    if(this.photo?.channel?.primaryColor?.hex) {
      var style = document.createElement( 'style' )
      style.innerHTML = `.photoWrapper { --as-player-btn-color: ${this.photo.channel.primaryColor.hex}; }`;
      this.el.shadowRoot.appendChild( style );
    }

    if(this.photo || this.placeholder) {
      // if(!this.sw) {
      //   this.sw = this.el.getBoundingClientRect().width;
      //   this.sh = this.el.getBoundingClientRect().height;
      // }
      var vidEl = this.el.shadowRoot.querySelector('.as-photo-wrapper');
      const s = this;
      // this.resetHeight(vidEl, s);

      if(!this.fullscreen && this.playclick && this.mode!='pinned') {
        // not pinned and play click exists - can be carousel or grid
        this.playControlClick = () => this.widgetPlayClick(s);
      }

      //pip
      this.closePipClick = () => {
        s.hidden = true;
        s.trackEvent('closed', {
          category: 'floating_photo_viewer',
        });
      }

      if(this.mode === 'pinned') {
        this.playControlClick = () => this.pipFullScreen(vidEl, s);
        this.playclick = () => this.playControlClick();
      }
      

      this.enterPipClick = (clicked = true, click_type = 'icon') => {
        console.log('enter pip click');
        if(!s.handlerPipMode) {
          s.fullscreen = false;
          s.enablePip();
        } else {
          s.piphandler();
        }
        if(clicked) {
          s.trackEvent('closed_click', {
            click_type,
            category: s.getViewerCategory(),
            ...s.getCtaAttributes(s)
          })
        }
      }

      this.backdropClick = () => {
        console.log('back drop click');

        if(this.mode === 'pinned') {
          this.enterPipClick(true, 'backdrop');
        } else {
          this.fullscreen = false;
        }
      }
    }
  }

  render() {
      
      if(this.loading) {
        return (
          <Host>

<div class={{ photoWrapper: true,
          'as-photo-wrapper': true,
          'pinned': (this.mode === 'pinned' && !this.fullscreen),
          'fullscreen': (this.fullscreen && this.mode==='pinned' || this.widget==='carousel_photo_viewer_fullscreen'),
          'br': (this.position === 'br'),
          'bl': (this.position === 'bl'),
          'tr': (this.position === 'tr'),
          'tl': (this.position === 'tl'),
          'hidden': (this.hidden),
          'sizemini': (this.size === 'mini'),
          }} 
          id={`as-photo-viewer-${this.photo?.id || Date.now()*Math.random()}`}
          style={{ width: `${this.w && !this.fullscreen ? this.w : '100%'}`, height: `${this.h ? this.h : (this.fullscreen || this.sw<576 ? '100vh' : '75vh')}` }}
          >

<div class="cards fullheight">
        <div class="card_image loading"></div>
        <div class="card_title loading"></div>
        {/* <div class="card_description loading"></div> */}
      </div>
      </div>

  

          </Host>
        )
      } else {

      return (
        <Host>
          {this.mode === 'pinned' && <div 
          class={{ backdrop: (this.mode === 'pinned'), 
          fullscreen: this.fullscreen 
          }} onClick={this.backdropClick}></div>}
          {(!this.loading) && <div class={{ photoWrapper: true,
          'as-photo-wrapper': true,
          'pinned': (this.mode === 'pinned' && !this.fullscreen),
          'fullscreen': (this.fullscreen && this.mode==='pinned' || this.widget==='carousel_photo_viewer_fullscreen'),
          'br': (this.position === 'br'),
          'bl': (this.position === 'bl'),
          'tr': (this.position === 'tr'),
          'tl': (this.position === 'tl'),
          'hidden': (this.hidden),
          'sizemini': (this.size === 'mini'),
          }} 
          id={`as-photo-viewer-${this.photo?.id || Date.now()*Math.random()}`}
          style={{ width: `${this.w && !this.fullscreen ? this.w : '100%'}`, height: `${this.h ? this.h : (this.fullscreen || this.sw<576 ? '100vh' : '75vh')}` }}
          >


        {!this.productoverlay && <as-product-overlay trackevent={this.trackEvent} env={this.env}></as-product-overlay>}

        {!this.photo && this.mode !== 'pinned' && (
                  <div class="cards">
                  <div class="card_image loading"></div>
                  <div class="card_title loading"></div>
                  {/* <div class="card_description loading"></div> */}
                </div>
                )}

        { this.photo && (<div style={{ height: '100%', position: 'relative'}}>
        <div
        class="photoviewer"
        style={{
          aspectRatio: `(${this.w ? this.w.replace('px', '') : 9})/(${this.h ? this.h.replace('px', '') : 16})`
        }}
        // ref={el => {
        //   this.viewer = el;
        // }}
        >
     
          <img class="lazy" style={{ objectFit: 'cover' }} alt={this.photo.title} data-src={this.photo.finalUrls['576'] || "https://cdnv2.allstudio.live/video-poster-placeholder.png"} />
          

        </div>

        <div class="flexWrapper">
            <main class="vmWrapper">

          {this.showheader && <div class={{ topPlayerShow: true }}></div>}
          <div class={{ bottomPlayerShow: true }}></div>

            {(this.playclick && !this.fullscreen) ? (
              <div class="fullphotoviewerclick" onClick={this.playControlClick}>
                <div style={{ height: `${this.h}` }} 
                ></div>
              </div>
            ) : <div></div>}


            {this.showheader ? (
              <div class="topRight controls">
                {this.showheadertitle ? (<div class={{
                  photoTitle: true,
                }}><span class={{ photoTitleText: true }}>{this.photo.title}</span></div>): (<div></div>)}
               
                {!this.fullscreen && this.mode!='pinned' && <div></div>}
       
                {this.mode ==='pinned' && !this.fullscreen && <div class="closeIcon control" onClick={this.closePipClick}>
                <div class="icon" role="img" aria-label="Close"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path>
</svg></div></div>}
                {this.fullscreen && (this.mode ==='pinned') && <div class="pipIconControl closeIcon" onClick={this.enterPipClick}>
                <div class="icon" role="img" aria-label="Close"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path>
</svg></div></div>}
                {this.fullscreen && (this.handlerPipMode) && <div class="pipHandlerIconControl" onClick={this.enterPipClick}>
                  <div class="closeIcon control">
                  <div class="icon" role="img" aria-label="Close"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path>
</svg></div>
                  </div>
                </div>}
                {this.fullscreen && this.mode!=='pinned' && !this.handlerPipMode && (<div style={{width: '30px', height:'28px'}}></div>)}
              </div>
            ):(<span></span>)}

            {this.showfootertitle ? (
              <div class="bottomLeft controls">
                <div class={{
                  footerTitle: true,
                }}><span class={{ footerTitleText: true }}>{this.photo.title}</span></div>
              </div>
            ):(<span></span>)}

          </main>

        {!this.showfootertitle && this.showheadertitle && this.photo.shoppableType === 'cta' 
            && this.photo.shoppableData?.ctaLink !== '' && (
              <footer class="ctaLinkContainer">
                <a class={{
                  ctaLink: true,
                  large: (this.photo.channel.ctaButtonSize === 'large'),
                  small: (this.photo.channel.ctaButtonSize === 'small'),
                }} style={{
                  "color": `${this.photo.channel.textColor.hex}`,
                  "background-color": `${this.photo.channel.primaryColor.hex}`,
                }} href={this.photo.shoppableData?.ctaLink} title={this.photo.shoppableData?.ctaType} >{this.photo.shoppableData?.ctaType}</a>
              </footer>
            )}

          {!this.showfootertitle && this.showheadertitle && this.platform === 'shopify' && this.photo.shoppableType === 'addtocart' 
            && this.shopifyVariantId && (
              <footer class="ctaLinkContainer">
                {this.addedToCart ? <div class="toastMessage">Item added to cart.</div> :
                <a class={{
                  ctaLink: true,
                  large: (this.photo.channel.ctaButtonSize === 'large'),
                  small: (this.photo.channel.ctaButtonSize === 'small'),
                }} style={{
                  "color": `${this.photo.channel.textColor.hex}`,
                  "background-color": `${this.photo.channel.primaryColor.hex}`
                }} onClick={async (e) => { 
                  e.preventDefault(); 
                  if(!this.addToCartLoading) 
                    await this.addShopifyItem();
                }} 
                title={this.photo.shoppableData?.ctaType}>{this.addToCartLoading ? (<div class="lds-ring"><div></div><div></div><div></div><div></div></div>) : this.photo.shoppableData?.ctaType}</a>}
              </footer>
            )}

{this.showproductchip && this.photo.shoppableData?.products && !this.loading && this.playclick ? (
  <footer class="ctaLinkContainer">
              <as-product-chip size={this.size} onClick={this.playControlClick} trackevent={this.trackEvent} products={this.photo.shoppableData?.products}></as-product-chip>
              </footer>
            ):(<span></span>)}

{this.showproductcard && this.photo.shoppableData?.products && !this.loading ? (
  <footer class="ctaLinkContainer">
            <as-product-card-slider
              products={this.photo.shoppableData?.products}
              overlay={this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay')}
              channel={this.photo.channel} photoviewer={this} trackevent={this.trackEvent}></as-product-card-slider>
              </footer>
            ):(<span></span>)}
            

            </div>

      </div>) }
        </div>}

        </Host>
      );
}
    } 

  getApiUrl (env?: string): string {
    let apiUrl = `https://apiv2.allstudio.live`;
    if(env === 'dev') {
      apiUrl = `${apiUrl}/dev`
    } else if(env === 'qa') {
      apiUrl = `${apiUrl}/qa`
    }
    return apiUrl;
  }
  
  getPhotoUrl (vid: any): string {
    let finalUrl: string = vid.url;
    try {
      if (vid.finalUrls) {
        finalUrl = vid.finalUrls['576'];
      } 
    } catch(e) {
      finalUrl = vid.url;
    }
    // console.log('finalUrl', finalUrl);
    return finalUrl;
  }

  resetHeight(vidEl, s){
    // reset the body height to that of the inner browser
    // s.sh = window.innerHeight;
    // console.log('window inner height', s.sh);
    this.setPlayerHeight(vidEl, s);
  }

  setPlayerHeight(vidEl, s): void {
    const ch = s.el.getBoundingClientRect();
    // console.log('ch final', ch, s.fullscreen);
    if(s.w || s.h) {
      // console.log('defined final', s.w, s.h, s.fullscreen);
      if(s.fullscreen) {
        s.h = `${s.sh}px`;
      }
    } else {
      // const cw = this.el.clientHeight;
      let vw = ch.width;
      let vh = s.sh || ch.height;
      // console.log('sw sh final', s.sw, s.sh);
      if(vw === 0 && vh === 0) {
        vw = s.sw || 0;
        vh = s.sh || 0;
      }
      if(vw === 0) {
        if(vh === 0) {
          vh = 320;
        }
        vw = vh*9/16;
      } else if (vh > 0 && vh > vw*16/9 ) {
        const tw = vh*9/16
        if(tw > vw && !this.fullscreen) {
          vh = vw*16/9;
        } else if(vw === 0 && tw>0 && !this.fullscreen){
          vw = tw;
        }
      } else {
        if(vh === 0) {
          // console.log('setting photo height', vidEl);
          if(!s.fullscreen) {
            vidEl.setAttribute('style', 'height:75vh;');
          } else {
            vidEl.setAttribute('style', 'height:100vh;');
          }
          vh = vidEl.getBoundingClientRect().height;
          vw = vidEl.getBoundingClientRect().width;
        } else {
          if(vh < vw && vh > 100) {
            vw = vh*9/16;
          } else {
            vh = vw*16/9;
          }
        }
      }
      // if(vh > ch.height && ch.height> 100) {
      //   vh = ch.height;
      //   vw = vh*9/16;
      // }

      if(vw > 576) {
        vw = 576;
        vh = vw*16/9;
      }

      // console.log('vw final', vw);
      s.w = `${vw}px`;
      s.h = `${vh}px`;
      // }
    }
    // console.log('final height', s.w, s.h, this.fullscreen);
  }

  enablePip() {
    this.w = '180px';
    this.h = '320px';
    this.showheader = true;
    this.showfootertitle = false;
    this.showheadertitle = false;
    this.showfooterplay = true;
  }

  pipFullScreen(vidEl, s) {
    console.log('full screen pip');
    s.trackEvent('full_screen', {
      category: 'floating_photo_viewer',
    });
    s.w = null;
    s.h = null;
    s.fullscreen = true;
    s.showheadertitle = true;
    s.showfooterplay = false;
    // s.w = '100%';
    // s.h = '100vh';
    s.setPlayerHeight(vidEl, s);

    // s.trackEvent('view', {
    //   category: 'fullscreen_photo_viewer',
    //   ...s.getCtaAttributes(s),
    // });

  }

  getCtaAttributes(s) {
    if (s.fullscreen) {
      return {
        cta_type: s.photo?.shoppableType,
        cta_title: s.photo?.shoppableData?.ctaType,
        products_count: (s.photo?.shoppableType === 'addtocart') ? 1 : 0, 
      };
    } else {
      return {

      };
    }
  }

  async addShopifyItem() {
    this.addToCartLoading = true;
    this.trackEvent('addtocart_click', {
      ...this.getCtaAttributes(this),
      category: 'fullscreen_photo_viewer',
      addtocart_id: this.shopifyVariantId,
      productid: this.shopifyProduct.product.id,
    });
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: this.shopifyVariantId,
            quantity: this.shopifyQty,
        })
    });
    this.addToCartLoading = false;
    if(result.status === 200) {
      this.addedToCart = true;
      this.trackEvent('addtocart_success', {
        ...this.getCtaAttributes(this),
        category: 'fullscreen_photo_viewer',
        addtocart_id: this.shopifyVariantId,
        productid: this.shopifyProduct.product.id,
      });
      const data = await result.json();
      if(!result.redirected) {
        var s = this;
        setTimeout(function() {
          window.location.reload();
          s.enterPipClick(false);
        }, 600);
      }
      return data;
    } else {
      this.trackEvent('addtocart_failure', {
        ...this.getCtaAttributes(this),
        category: 'fullscreen_photo_viewer',
        addtocart_id: this.shopifyVariantId,
        productid: this.shopifyProduct.product.id,
      });
      return false;
    }
  }

  async onShopifyProductPage() {
    const w: any = window;
    const path = w.location.pathname;
    // The pathname most likely looks like /collections/something/products/product-handle
    const potentialHandle = path.substring(path.lastIndexOf("/") + 1);
    if(w?.meta && w.meta?.product.id) {
      console.log('returning p from meta');
      this.shopifyProduct = w.meta;
      this.shopifyVariantId = this.shopifyProduct?.product?.variants[0].id || null;
      return this.shopifyProduct;
    }
    const result = await fetch(`/products/${potentialHandle}.json`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    });

    if (result.status === 200) {
      this.shopifyProduct = await result.json();
      this.shopifyVariantId = this.shopifyProduct?.product?.variants[0].id || null;
      return this.shopifyProduct;
    } else {
      return false;
    }
  }

  getViewerCategory() {
    if (this.fullscreen && this.mode === 'pinned') {
      return 'fullscreen_photo_viewer';
    }
    return this.widget;
  }

  widgetPlayClick(s) {
    console.log('widget play click', s.widget);
    s.trackEvent('full_screen', {
      category: s.getViewerCategory(),
    });

    s.playclick();
  
    // s.trackEvent('view', {
    //   category: `${s.widget}_fullscreen`,
    //   ...s.getCtaAttributes(s),
    // });

  }

  setJitsu(s) {
    jitsu.set({
      channelid : s.photo.channelId,
      photoid: s.photo.id,
      width: s.photo.width,
      height: s.photo.height,
      category: s.widget,
      env: s.env === '' ? 'live' : s.env,
      appid: 'allstudio',
      accountid: s.photo?.channel?.accountId,
      playlistid: s.playlistId,
      index: s.index,
      type: 'photo',
      typeId: s.photo.id,
      videoid: null,
    });

    // posthog.group('accountid', `${s.env === 'live' || s.env === '' ? '': `${s.env}_`}${s.photo?.channel?.accountId}`, {
    //   env: s.env,
    //   channelid: s.photo.channelId,
    //   channel: s.photo?.channel?.title,
    // });
    try {
      // posthog.register_once({
      //   channelid : s.photo.channelId,
      //   photoid: s.photo.id,
      //   width: s.photo.width,
      //   height: s.photo.height,
      //   category: s.widget,
      //   env: s.env === '' ? 'live' : s.env,
      //   appid: 'allstudio',
      //   accountid: s.photo?.channel?.accountId,
      //   playlistid: s.playlistId,
      //   index: s.index,
      //   type: 'photo',
      //   typeId: s.photo.id,
      //   videoid: null,
      // }); 
    } catch(e) {
      
    }
  }

  async onIntersection (entries) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        if (this.observer) {
           this.observer.disconnect();
        }
        this.loadImg();
      }
    }
  };

  async loadImg() {
    var img = this.el.shadowRoot.querySelector('img');
        img.setAttribute('src', img.getAttribute('data-src'));
        this.imgloaded = true;
  }

  trackEvent(name, data, s = null) {
    if(!s) {
      s = this;
    } else {
      s.setJitsu(s);
    }
    if(s.tk || s.tk === undefined) {
      // console.log('tracking event', name, data);
      try {
        jitsu.track(name, data);
        // posthog.capture(name, data);
      } catch(e) {
        console.log('jitsu tracking error', e);
      }
    }
  }

}

// const liftP = func => (...args) =>
//   Promise.all(args).then(values => func(...values))

// const getVideo = (photo) => photo
// const getVideoL = liftP(getVideo);
